/**
 * Native replacements for Lodash array utilities
 */

/**
 * Creates a duplicate-free version of an array using an iteratee function
 * @example uniqBy([{ id: 1 }, { id: 2 }, { id: 1 }], item => item.id) // [{ id: 1 }, { id: 2 }]
 */
export function uniqBy<T>(array: T[], iteratee: (item: T) => unknown): T[] {
  const seen = new Set();
  return array.filter(item => {
    const key = iteratee(item);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}

/**
 * Sorts an array by one or more iteratee functions
 * @example sortBy([{ age: 40 }, { age: 20 }], item => item.age) // [{ age: 20 }, { age: 40 }]
 */
export function sortBy<T>(
  array: T[],
  iteratee: ((item: T) => unknown) | ((item: T) => unknown)[],
): T[] {
  const iteratees = Array.isArray(iteratee) ? iteratee : [iteratee];

  return [...array].sort((a, b) => {
    for (const fn of iteratees) {
      const aVal = fn(a);
      const bVal = fn(b);

      if ((aVal as string | number) < (bVal as string | number)) return -1;
      if ((aVal as string | number) > (bVal as string | number)) return 1;
    }
    return 0;
  });
}
